import { LayoutServiceContext } from '@sitecore-content-sdk/nextjs';

export function getGmiSiteId(sitecoreContext: LayoutServiceContext) {
  const siteId = sitecoreContext.siteSettings?.profileSiteId?.value;
  if (!siteId) {
    console.error('Site ID not found');
  }
  return siteId;
}

export function getSearchConfigurationId(sitecoreContext: LayoutServiceContext) {
  const searchConfigurationId = sitecoreContext.siteSettings?.searchConfigurationId?.value;
  if (!searchConfigurationId) {
    console.warn('Search Configuration ID (optional setting) not found');
  }
  return searchConfigurationId;
}

export function getSubscriptionId(sitecoreContext: LayoutServiceContext) {
  const subscriptionId = sitecoreContext.siteSettings?.subscriptionID?.value;
  if (!subscriptionId) {
    console.error('Subscription ID not found in site settings');
  }
  return subscriptionId;
}
